import { freightHandlingUnitIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";

export const setDefaultFreightHandlingUnit = {
  name: "setDefaultFreightHandlingUnit" as const,
  input: z.object({ id: freightHandlingUnitIdFormat.schema }),
  output: z.object({}),
};
